import './ProjectPartners.css';

export default function ProjectPartners({ project }) {
  const partners = project.partners || [];
  if (!partners.length) return null;

  return (
    <section className="pd-section pd-partners">
      <p className="pd-eyebrow">Developer &amp; Partners</p>
      <h2 className="pd-title">Who’s behind <em>the development</em></h2>

      <div className="pd-partners__grid">
        {partners.map((p) => (
          <div key={`${p.role}-${p.name}`} className="pd-partner">
            <span className="pd-partner__role">{p.role}</span>
            {p.logo ? (
              <img className="pd-partner__logo" src={p.logo} alt={p.name} loading="lazy" />
            ) : (
              <span className="pd-partner__name">{p.name}</span>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
